// append this list when you add a new device
export enum DEVICES {
    PC303 = 'PC303',
    PM6100 = 'PM6100',
    F4 = 'F4', // connected weight scale
    SCHILLER_ECG = 'ECGSchiller',
    THERMO_TAIDOC = 'TAIDOC TD1242',
    TAIDOC_BGMETER = 'TAIDOC BGMETER',
    WELCH_ALLYN_CONNEX_SPOT_MONITOR = 'Connex Spot Monitor',
    ECG_WATCH_FOLDER = 'ECG_WATCH_FOLDER',
    PM6100_BLE = 'PM6100_BLE',
    SE_1515 = 'SE-1515',
    TOUCH_ECG = 'TOUCH_ECG',
    IM3S = 'IM3S',
    IM3S_BLE = 'IM3S_BLE',
    MIR_SPIROMETRY = 'MIR_SPIROMETRY',
    HDSTETH = 'HDSteth', // HD Medical electronic stethoscope (BLE)
}

export enum DEVICE_TYPE {
    SERIAL = 'serial',
    BLE = 'ble',
}

export type MedconnectDeviceValue = {
    name: DEVICES
    type: DEVICE_TYPE
    port?: string
    baudrate?: 9600 | 115200
    receiver_name?: string
    sender_name?: string
    gdt_folder_path?: string
    ecg_folder_path?: string;
    filePrefix?: string;
    fileSuffix?: string;
    mir_protocol?: string;
    mir_software_type?: string;
    mir_exchange_folder?: string;
    mir_exchange_folder_exchange?: string;
    mir_program_path?: string;
    ecg_program_path?: string;
    ble_name?: string;
    ble_id?: string;
}

export type MedconnectDevice = MedconnectDeviceValue & {
    _id: string
}

export type MedconnectDevicesConfig = {
    SUPPORT_NAME: string
    INSTALLER_NAME: string
    Devices: MedconnectDevice[]
}

import pc303ImgUrl from '@/assets/images/devices/taidoc-pc303.jpg'
import pm6100ImgUrl from '@/assets/images/devices/berrymed-pm6100.png'
import f4ImgUrl from '@/assets/images/devices/viatom-f4-scale.jpg'
import ecgSchillerImgUrl from '@/assets/images/devices/schiller-cs104.jpg'
import taidocTd1242ImgUrl from '@/assets/images/devices/taidoc-td1242.jpg'
import taidocBgmeterImgUrl from '@/assets/images/devices/taidoc-bgmeter.jpg'
import connexSpotMonitorImgUrl from '@/assets/images/devices/welch-allyn-connex-spot-monitor.jpg'
import ecgWatchFolderImgUrl from '@/assets/images/devices/ecg-watch-folder.png'
import se1515ImgUrl from '@/assets/images/devices/edan-se1515.jpg'
import touchEcgImgUrl from '@/assets/images/devices/cardioline-touchecg.jpg'
import im3sImgUrl from '@/assets/images/devices/edan-im3s.png'
import mirSpirometryImgUrl from '@/assets/images/devices/mir-spirolab.jpg'
import hdStethImgUrl from '@/assets/images/devices/hd-steth.png'

export const DEVICE_IMG = {
    "PC303": pc303ImgUrl,
    "PM6100": pm6100ImgUrl,
    "F4": f4ImgUrl,
    "ECGSchiller": ecgSchillerImgUrl,
    "TAIDOC TD1242": taidocTd1242ImgUrl,
    "TAIDOC BGMETER": taidocBgmeterImgUrl,
    "Connex Spot Monitor": connexSpotMonitorImgUrl,
    "ECG_WATCH_FOLDER": ecgWatchFolderImgUrl,
    "PM6100_BLE": pm6100ImgUrl,
    "SE-1515": se1515ImgUrl,
    "TOUCH_ECG": touchEcgImgUrl,
    "IM3S": im3sImgUrl,
    "IM3S_BLE": im3sImgUrl,
    "MIR_SPIROMETRY": mirSpirometryImgUrl,
    "HDSteth": hdStethImgUrl
}

/** A device the connector knows how to drive, as served by GET device-profiles. */
export type ConnectorDeviceProfile = {
    name: DEVICES
    displayName: string
    type: DEVICE_TYPE
    advertisedNamePatterns?: string[]
    supportsDeviceSelection: boolean
}

/** A serial port present on the computer running the connector. */
export type ConnectorSerialPort = {
    path: string
    manufacturer: string | null
    friendlyName: string | null
}

export type ConnectorBleDevice = {
    id: string;
    name: string;
    rssi: number | null;
}

export type ConnectorHealth = {
    status: 'ok' | 'degraded';
    uptimeSeconds: number;
    bluetooth: {
        state: string;
        scanning: boolean;
        lastDiscoveryAt: number | null;
        lastStateChangeAt: number;
        recoveryCount: number;
        lastError: string | null;
    } | null;
    devices: Array<{
        /** Driver's internal name (e.g. "BerryMed"); may differ from the configured name. */
        name: string;
        /** Configuration entry the running device was created from. */
        configId: string | null;
        configName: string | null;
        alive: boolean;
        connected: boolean | null;
    }>;
}

export type ConnectorReleaseManifest = {
    channel: string;
    /** Shared fallback; a platform entry's own `version` wins (platforms can release independently). */
    version: string;
    windows?: { version?: string; url: string; sha256: string };
    macos?: { version?: string; url: string; sha256: string; zipUrl?: string; zipSha256?: string };
}
